/** The reference helmet script (design-reference lines 84–108): titlebar lift/condense on main scroll and rail fade markers.
 *  Ported verbatim as a mount-once effect with the same MutationObserver wiring. */
export function installChrome(): () => void {
  const scEl = () => document.querySelector<HTMLElement>('[data-tb-scroll]');
  let wiredSc: HTMLElement | null = null;
  const onScroll = () => {
    const bar = document.querySelector<HTMLElement>('[data-titlebar]');
    const sc = scEl();
    if (!bar || !sc) return;
    const y = sc.scrollTop;
    bar.classList.toggle('lifted', y > 2);
    bar.classList.toggle('condensed', y > 42);
  };
  function wire(): boolean {
    const bar = document.querySelector('[data-titlebar]');
    const sc = scEl();
    if (!bar || !sc) return false;
    if (wiredSc === sc) return true;
    if (wiredSc) wiredSc.removeEventListener('scroll', onScroll);
    wiredSc = sc;
    sc.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return true;
  }
  const seen = new WeakSet<Element>();
  const sync = () => {
    document.querySelectorAll<HTMLElement>('.rail-scroll').forEach((sc) => {
      const slab = sc.closest<HTMLElement>('.rail-viewport') || sc.parentElement;
      if (!slab) return;
      const upd = () => {
        slab.setAttribute('data-up', sc.scrollTop > 1 ? '1' : '0');
        slab.setAttribute('data-down', sc.scrollTop + sc.clientHeight < sc.scrollHeight - 1 ? '1' : '0');
      };
      if (!seen.has(sc)) {
        seen.add(sc);
        sc.addEventListener('scroll', upd, { passive: true });
      }
      upd();
    });
    wire();
  };
  sync();
  const mo = new MutationObserver(sync);
  mo.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', sync, { passive: true });
  return () => {
    mo.disconnect();
    window.removeEventListener('resize', sync);
    if (wiredSc) wiredSc.removeEventListener('scroll', onScroll);
  };
}
